module.exports = __webpack_public_path__ + "img/feat_safe.4abceeaa.png";